module.exports = __webpack_public_path__ + "static/media/5363873822980255325.20b85a39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5363873822980255325.jpg
// module id = 86
// module chunks = 0